import React, { Component, useState, useEffect } from 'react'
import PageHead from '../../components/pageHead';
import Layout from '../../components/Layout';
import '../../sass/_get-estimate.scss';
import '../../sass/_services-details.scss';
import '../../sass/_home.scss';
import '../../sass/_case-study-details.scss';
import { Container, Row, Col, Form } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import Cbutton from '../../components/button';
import Slider from 'react-input-slider';
import SpectialComponent from '../../components/hoverEffect';
import Header from '../../components/header';
import GetEstFrom from '../../components/getEstimateForm/index';
import GetEstServices from '../../components/getEstimateServices';
export default function index() {
    const [state, setState] = useState({ x: 15000 });
    return (
        <div>
            <Header name="get-estimate" />
            <PageHead title="AXLR DATA PVT LTD | Software Solutions"></PageHead>
            <Layout>
                <section className="devalopement-sec">
                    <Container>
                        <div className="mt-4 mb-sm-5 pt-5 pb-sm-5">
                            <Row>
                                <Col className="pl-sm-0 pr-sm-0" md={8}>
                                    <div className="">
                                        <div className="big-heading pt-sm-2 get-estimate009-sd">Let<span className="avoid-extra-c">'s</span> get</div>
                                        <div className="big-heading pt-sm-2 get-estimate-sd">Started!</div>
                                        <div className="spectial-content pt-sm-5 pl-sm-3">
                                            Help us understand your ideas through this simple form
                                       </div>
                                    </div>
                                </Col>
                                <Col className="text-center">
                                    <img src={`${publicRuntimeConfig.staticFolder}/images/get-estimate-top.png`} alt="get-estimate-top" className="mt-2 w-100 spectial" />
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </section>
                <section className="mt-5 pt-sm-5">
                    <Container>
                        <Row>
                            <Col>
                                <div className="get-sdf-heading">
                                    What kind of service are you looking for?
                                 </div>
                            </Col>
                            <Col md={3} className="spectial-left-border">
                                <div className="mt-5 mb-sm-3 pt-1 pb-5">
                                <a href="tel: 988 581 2693" className="link-action">
                                    <Cbutton name="Talk to us" />
                                </a>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section>
                    <Container>
                        <GetEstServices />
                    </Container>
                </section>
                <section className="mb-sm-3 pt-sm-2 pb-5" id="form">
                    <Container>
                        <Row>
                            <Col>
                                <div className="get-sdf-heading">
                                    Tell us a little about your project
                                 </div>
                            </Col>
                            <Col md={3} className="spectial-left-border">
                                <div className="mt-5 mb-sm-3 pt-sm-1 pb-5">
                                <a href="tel: 988 581 2693" className="link-action">
                                      <Cbutton name="Talk to us" />
                                </a>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <Form className="pt-sm-4 my-axlr-form">
                                    <GetEstFrom budget={state.x} />
                                    <Row>
                                        <Col>
                                            <Form.Label className="case-study-heading pt-3">What is your budget?</Form.Label>
                                            <div className="custome-slider-conroller">
                                                <Slider
                                                    axis="x"
                                                    xstep={100}
                                                    xmin={1000}
                                                    xmax={100001}
                                                    x={state.x}
                                                    onChange={({ x }) => setState({ x: parseFloat(x.toFixed(2)) })}
                                                    className="w-100"
                                                />
                                                <div>{'$' + state.x+'.00'}</div>
                                            </div>
                                        </Col>
                                    </Row>
                                     <br className="mobile" />
                                    <br className="mobile" />
                                    <br className="desktop" />
                                    <br className="desktop" />
                                </Form>
                            </Col>
                            <Col>
                                <img src={`${publicRuntimeConfig.staticFolder}/images/form-df-img.png`} alt="form-df-img" className="mt-sm-5 desktop" />
                            </Col>
                        </Row>
                    </Container>
                </section>
                {/* <section>
                    <Container>
                        <SpectialComponent />
                    </Container>
                </section> */}
            </Layout>
            <style jsx global>
                {`
                .main-btn{
                    font-family : 'PT Mono', monospace;
                }
                body{
                    overflow-x: hidden;
                }
                .css-yvszuv-Slider {
                    border-radius: 100px;
                    border: 1px solid #000000;
                    background: #FFFFFF;
                    height: 15px;
                }
                .case-study-heading{
                    font-size: 15px !important;
                }
                .get-estimate009-sd{
                    font-size: 115px;
                    letter-spacing: 0px;
                }
                .get-estimate-sd{
                    font-size: 135px;
                    letter-spacing: 0px !important;
                }
                `}
            </style>
        </div>
    )
} 